import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=41e1caa3&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/content.scss?vue&type=style&index=0&id=41e1caa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1caa3",
  null
  
)

export default component.exports